import { Component, OnInit, ViewChild, ElementRef, HostListener } from '@angular/core';
import { AbstractControl, FormControl, FormGroupDirective, NgForm, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { EventService } from 'src/app/core/services/event.service';
import { ApiService } from 'src/app/shared/services/api.service';
import { TranslateService } from '@ngx-translate/core';
import Swal from 'sweetalert2';
import { NgbDate, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { CommonService } from 'src/app/shared/services/common.service';
import { AuthfakeauthenticationService } from 'src/app/core/services/authfake.service';
import { of } from 'rxjs';
import { MatInput } from '@angular/material/input';

/** Error when invalid control is dirty, touched, or submitted. */
export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}
interface OrderItem {
  name: string;
  quantity: number;
  servicePeriod: string;
  price: string;
  imageUrl: string;

}

interface OrderSummary {
  item: OrderItem;
  subtotal: string;
  shippingFee: string;
  total: string;
}
@Component({
  selector: 'app-form-page',
  templateUrl: './form-page.component.html',
  styleUrls: ['./form-page.component.scss']
})
export class FormPageComponent implements OnInit {
  windowHeight: number;

  id = JSON.parse(localStorage.getItem('currentUser')).id
  userToken = JSON.parse(localStorage.getItem('currentUser')).user_token
  serviceType = localStorage.getItem('serviceType')
  selectedProvince: any = -1
  selectedDistrict: any = -1
  selectedWard: any = -1
  listProvince: any[] = []; // Danh sách các tỉnh/thành phố
  listDistrict: any[] = []; // Danh sách các quận/huyện
  listWard: any[] = []; // Danh sách các xã/phường
  orderForm: FormGroup;
  isTermsAgreed: boolean = true; // Biến theo dõi trạng thái checkbox
  registrationData: any;
  dataUser: any[] = []
  listDataWs: any[] = []
  referrerCode = ''
  constructor(
    private commonService: CommonService,
    public eventService: EventService,
    private apiService: ApiService,
    public activatedRoute: ActivatedRoute,
    private translateService: TranslateService,
    private modalService: NgbModal,
    public formBuilder: FormBuilder,
    private router: Router,
    private http: HttpClient,
    public authFackservice: AuthfakeauthenticationService,

  ) {
    this.windowHeight = window.innerHeight;
    this.orderForm = this.formBuilder.group({
      storeName: ['', this.conditionalValidator(() => !this.orderForm?.get('selectedStore')?.value, Validators.required)],
      storeAddress: ['', this.conditionalValidator(() => !this.orderForm?.get('selectedStore')?.value, Validators.required)],
      qrAccount: ['', this.conditionalValidator(() => !this.orderForm?.get('selectedStore')?.value, Validators.required)],
      accountOwner: ['', this.conditionalValidator(() => !this.orderForm?.get('selectedStore')?.value, Validators.required)],
      recipientName: [''],
      recipientPhone: ['', [Validators.pattern(/^(03|05|07|08|09)\d{8}$/), Validators.minLength(10), Validators.maxLength(10)]],
      province: [''],
      district: [''],
      ward: [''],
      address: [''],
      selectedStore: ['']
    });

    this.orderForm.get('selectedStore')?.valueChanges.subscribe((value) => {
      ['storeName', 'storeAddress', 'qrAccount', 'accountOwner'].forEach(field => {
        const control = this.orderForm.get(field);
        if (value) {
          control?.clearValidators();
        } else {
          control?.setValidators(Validators.required);
        }
        control?.updateValueAndValidity();

        // Thực hiện việc chặn ký tự không hợp lệ
        const currentValue = control.value;
        if (currentValue !== null) {
          const sanitizedValue = currentValue.replace(/[^\p{L}\p{N}\s]/gu, '');
          control.setValue(sanitizedValue, { emitEvent: false });
        }
      });
    });
  }
  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    this.windowHeight = window.innerHeight; // Cập nhật chiều cao cửa sổ
    this.adjustLayout();
  }

  adjustLayout() {
    const shippingAddressSection = document.querySelector('.shipping-address') as HTMLElement; // Ép kiểu về HTMLElement
    if (shippingAddressSection) {
      if (this.windowHeight < 600) {
        shippingAddressSection.style.paddingBottom = '200px'; // Ví dụ tăng khoảng cách
      } else {
        shippingAddressSection.style.paddingBottom = '0'; // Đặt lại khoảng cách
      }
    }
  }
  noIconsValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const forbidden = /[!@#$%^&*(),.?":{}|<>]/.test(control.value);

      return forbidden ? { 'noIcons': { value: control.value } } : null;
    };
  }
  conditionalValidator(condition: () => boolean, validator: ValidatorFn): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (condition()) {
        return validator(control); // Không thay đổi giá trị trong validator
      }
      return null;
    };
  }
  onInputChange(event: Event, controlName: string): void {
    const input = event.target as HTMLInputElement;
    const sanitizedValue = input.value.replace(/[^\p{L}\p{N}\s]/gu, '');

    // Cập nhật giá trị của control tương ứng
    this.orderForm.get(controlName)?.setValue(sanitizedValue, { emitEvent: false });
  }

  ngOnInit(): void {
    this.registrationData = JSON.parse(localStorage.getItem('registrationData'));
    this.fetchData()
    this.getProvinces()
    this.fetchDataWs()

  }

  fetchDataWs() {
    this.eventService.setLoading(true)
    this.apiService.getList('workspacesV3'
    ).subscribe({
      next: (res) => {
        this.listDataWs = res['workspaces'] ? res['workspaces'] : [];
        this.eventService.setLoading(false)
      }
    })
  }
  addWorkspace() {
    document.querySelector('.modal-backdrop')?.remove();
    document.body.classList.remove('modal-open');
    document.body.style.overflow = '';
    const data = {
      name: this.orderForm.value.storeName,
      terminalAddress: this.orderForm.value.storeAddress,
      terminalBankAcc: this.orderForm.value.qrAccount,
      terminalBankName: '970422',
      terminalBankAccountName: this.orderForm.value.accountOwner
    }
    this.apiService.addItem("workspaces-v2", data).subscribe({
      next: res => {
        this.fetchDataWs()

        const workspaceId = res['metadata']?.workspaceId;
        localStorage.setItem('workspace', res['metadata']?.workspaceId);
        this.apiService.showToastMobile(this.translateService.instant('success'), this.translateService.instant('Thêm mới thành công'))
        this.orderForm.reset();
        this.eventService.setLoading(false)
        this.orderForm.get('selectedStore')?.setValue(workspaceId);
      },
      error: e => {
        if (e) {
          this.apiService.showToastMobile('error', this.translateService.instant(e))
          this.eventService.setLoading(false)
        } else {
          this.apiService.showToastMobile('error', this.translateService.instant('FORM.ErrorMessageAdd'))
          this.eventService.setLoading(false)
        }
      }

    })

  }
  getSelectedStore() {
    const selectedStoreId = this.orderForm.get('selectedStore').value;
    return this.listDataWs.find(store => store.id === selectedStoreId) || {};
  }
  onInputBlur() {
    this.eventService.setLoading(true);
    this.orderForm.patchValue({ accountOwner: '' });
    const qrAccountValue = this.orderForm.get('qrAccount')?.value || '';
    if (qrAccountValue === '') {
      this.dataUser = []
      this.eventService.setLoading(false);
      return
    }
    // if (this.orderForm.value.qrAccount !== 0) {
    //   this.dataUser = []
    //   this.eventService.setLoading(false);
    // }
    this.isTermsAgreed = false
    const data = {
      partner_id: this.id,
      accountNumber: this.orderForm.value.qrAccount,
      token: this.userToken
    };

    this.apiService.apiPostToPaydee('prod/bank/account-info', data)
      .subscribe(
        (response: any) => {
          console.log(response);
          if (response.returnCode == "0") {
            this.apiService.showToastMobile(
              'error',
              this.translateService.instant('Tài khoản không hợp lệ')
            );
          }
          if (response.ResponseData.errorCode === '200' && !response.ResponseData.data) {
            this.apiService.showToastMobile(
              'error',
              this.translateService.instant('Không tìm thấy tài khoản')
            );
          } else if (response.ResponseData.data) {
            this.isTermsAgreed = true;
            this.apiService.showToastMobile(
              this.translateService.instant('success'),
              this.translateService.instant('Tìm kiếm thành công')
            );
            this.orderForm.patchValue({
              accountOwner: response.ResponseData.data.accountName
            });
          } else {
            this.apiService.showToastMobile(
              'error',
              this.translateService.instant('Có lỗi xảy ra khi tìm kiếm tài khoản')
            );
          }

          this.eventService.setLoading(false);
        },
        (error) => {
          this.apiService.showToastMobile(
            'error',
            this.translateService.instant('Lỗi kết nối. Vui lòng thử lại sau.')
          );
          this.eventService.setLoading(false);
        }
      );
  }
  previousSection() {
    this.router.navigate(['/account/landing-page'], { queryParams: { section: 2 } });
  }
  onBack() {
    Swal.fire({
      // title: this.translateService.instant('FORM.Warning'),
      text: this.translateService.instant('Bạn có chắc chắn muốn đóng ứng dụng?'),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#141ED2',
      cancelButtonColor: 'fff',
      confirmButtonText: this.translateService.instant('FORM.WarningConfirm'),
      cancelButtonText: this.translateService.instant('FORM.Cancel'),
      customClass: {
        icon: 'my-custom-icon-class'
      }
    }).then(result => {
      if (result.value) {
        this.authFackservice.logoutMobile();
        setTimeout(() => {
          if (window['ReactNativeWebView']) {
            window['ReactNativeWebView'].postMessage(JSON.stringify({
              type: 'GO_BACK',
            }));
            console.log('Message posted to React Native WebView');
          } else {
            console.warn('ReactNativeWebView không tồn tại. Sử dụng môi trường local để test.');
            window['ReactNativeWebView'] = {
              postMessage: (message) => {
                console.log('Message posted to React Native (mock):', message);
              }
            };
            window['ReactNativeWebView'].postMessage(JSON.stringify({
              type: 'GO_BACK',
            }));
          }
        }, 2000);
      }
    });

  }
  fetchData() {
    this.apiService.getList('account-list'
    ).subscribe({
      next: (res) => {
        this.dataUser = res['metadata']['accountList'] ? res['metadata']['accountList'] : [];
      }
    })

  }
  getProvinces() {
    this.apiService.getList('viettel-post/province?provinceId=-1').subscribe({
      next: (res) => {
        this.listProvince = res;
      }
    })
  }

  onProvinceChange(provinceId) {
    this.apiService.getList('viettel-post/district?provinceId=' + provinceId?.PROVINCE_ID).subscribe({
      next: (res) => {
        this.listDistrict = res;
      }
    })
    this.listWard = []

  }

  onDistrictChange(districtId) {
    this.apiService.getList('viettel-post/ward?districtId=' + districtId.DISTRICT_ID).subscribe({
      next: (res) => {
        this.listWard = res;
      }
    })
  }
  inProgress = false;
  processPayment() {
    this.eventService.setLoading(true)
    if (this.inProgress) return;
    this.inProgress = true;
    if (this.isTermsAgreed) {
      this.eventService.setLoading(false)

      if (this.orderForm.valid) {
        let storeCreationObservable;

        if (this.orderForm.value.selectedStore) {
          storeCreationObservable = of({ metadata: { workspaceId: this.orderForm.value.selectedStore } });
        } else {
          const data = {
            name: this.orderForm.value.storeName,
            terminalAddress: this.orderForm.value.storeAddress,
            terminalBankAcc: this.orderForm.value.qrAccount,
            terminalBankName: '970422',
            terminalBankAccountName: this.orderForm.value.accountOwner
          };

          storeCreationObservable = this.apiService.addItem("workspaces-v2", data);
        }

        storeCreationObservable.subscribe({
          next: res => {
            localStorage.setItem('workspace', res['metadata']?.workspaceId);
            this.eventService.setLoading(false);

            const packageData = {
              packageId: this.registrationData.package.id,
              quantity: this.registrationData.product.quantity,
              referrer: this.referrerCode,
              customerName: this.orderForm?.value.recipientName,
              phone: this.orderForm?.value.recipientPhone,
              address: this.orderForm?.value.address,
              wardName: this.orderForm?.value.ward?.WARDS_NAME || '',
              wardName_id: this.orderForm?.value.ward?.WARDS_ID || '',
              districtName: this.orderForm?.value.district?.DISTRICT_NAME || '',
              districtName_id: this.orderForm?.value.district?.DISTRICT_ID || '',
              provinceName: this.orderForm?.value.province?.PROVINCE_NAME || '',
              provinceName_id: this.orderForm?.value.province?.PROVINCE_ID || '',
              deliveryMethod: this.serviceType,
            };

            this.apiService.postItem('customer-order-user', packageData).subscribe({
              next: (res: any) => {
                if (window['ReactNativeWebView']) {
                  window['ReactNativeWebView'].postMessage(JSON.stringify({
                    type: 'PAYMENT_HUB_TRANSACTION',
                    data: {
                      merchant: {
                        code: res.metadata.merchant_code,
                        name: res.metadata.merchant_name,
                      },
                      type: {
                        code: res.metadata.type_code,
                        name: res.metadata.type_name,
                        allowCard: true,
                      },
                      id: res.metadata.transaction_id,
                      amount: res.metadata.amount,
                      description: res.metadata.description,
                      successMessage: res.metadata.successMessage
                    }
                  }));
                } else {
                  console.log("Thanh toán thành công");
                }
                this.inProgress = false;
              },
              error: e => {
                if (e === 'Customer already has this package qr paybox') {
                  this.apiService.showToastMobile(
                    'error',
                    this.translateService.instant('Tài khoản đã sử dụng gói dịch vụ')
                  );
                } else {
                  this.apiService.showToastMobile(
                    'error',
                    this.translateService.instant('Đăng ký thất bại')
                  );
                }
                this.eventService.setLoading(false);
                this.inProgress = false;
              }
            });
          },
          error: e => {
            if (e) {
              this.apiService.showToastMobile(
                'error',
                this.translateService.instant(e)
              );
            }
            else {
              this.apiService.showToastMobile(
                'error',
                this.translateService.instant('Tạo cửa hàng thất bại')
              );
            }
            this.eventService.setLoading(false);
            this.inProgress = false;
          }
        });
      } else {
        this.showValidationErrors();
        this.inProgress = false;
      }
    } else {
      this.eventService.setLoading(false)

      this.apiService.showToastMobile(
        this.translateService.instant('warning'),
        this.translateService.instant('Vui lòng đồng ý với điều khoản dịch vụ.')
      );
    }
    this.eventService.setLoading(false)

  }

  private showValidationErrors(): void {

    const formControls = this.orderForm.controls;
    const formControlNames = Object.keys(formControls);
    for (const controlName of formControlNames) {
      const control = formControls[controlName];
      if (control.invalid) {
        const errors = control.errors;
        for (const errorKey in errors) {
          if (errors.hasOwnProperty(errorKey)) {
            let errorMessage: string;
            switch (controlName) {
              case 'storeName':
                errorMessage = 'Tên cửa hàng là bắt buộc.';
                break;
              case 'storeAddress':
                errorMessage = 'Địa chỉ cửa hàng là bắt buộc.';
                break;
              case 'qrAccount':
                errorMessage = 'Tài khoản QR là bắt buộc.';
                break;
              case 'accountOwner':
                errorMessage = 'Chủ tài khoản là bắt buộc.';
                break;
              case 'recipientName':
                if (this.serviceType = 'shipper') {
                  errorMessage = 'Tên người nhận là bắt buộc.';
                } else {
                  console.log();

                  continue;
                }
                break;
              case 'recipientPhone':
                if (this.serviceType = 'shipper') {
                  const phoneErrors = control.errors;
                  if (phoneErrors?.required) {
                    errorMessage = 'Số điện thoại là bắt buộc.';
                  }
                  if (phoneErrors?.pattern) {
                    errorMessage = 'Số điện thoại không hợp lệ.';
                  }
                } else {
                  continue;
                }
                break;
              case 'province':
                if (this.serviceType = 'shipper') {
                  errorMessage = 'Tỉnh/Thành phố là bắt buộc.';
                } else {
                  continue;
                }
                break;
              case 'district':
                if (this.serviceType = 'shipper') {
                  errorMessage = 'Quận/Huyện là bắt buộc.';
                } else {
                  continue;
                }
                break;
              case 'ward':
                if (this.serviceType = 'shipper') {
                  errorMessage = 'Phường/Xã là bắt buộc.';
                } else {
                  continue;
                }
                break;
              case 'address':
                if (this.serviceType = 'shipper') {
                  errorMessage = 'Địa chỉ cụ thể là bắt buộc.';
                } else {
                  continue;
                }
                break;
              case 'pattern':
                errorMessage = 'Thông tin không hợp lệ.';
                break;
              default:
                errorMessage = 'Có lỗi trong thông tin.';
                break;
            }

            if (errorMessage) {
              this.apiService.showToastMobile(this.translateService.instant('warning'), errorMessage);
            }
            break; // Ngừng vòng lặp sau khi hiển thị thông báo lỗi
          }
        }
      }
    }

  }
  onCheckboxChange(event: Event): void {
    const checkbox = event.target as HTMLInputElement;
    this.isTermsAgreed = checkbox.checked;
  }
  matcher = new MyErrorStateMatcher();
}
